var React = require('react');

function OfferInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.414 7.014l-8.278 8.279a1 1 0 0 1-1.415 0L.707 10.279a1 1 0 0 1 0-1.415L8.986.586A2 2 0 0 1 10.4 0H15a1 1 0 0 1 1 1v4.6a2 2 0 0 1-.586 1.414zM12.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z","fill":"currentColor","fillRule":"evenodd"}));
}

OfferInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = OfferInline;

OfferInline.default = OfferInline;
